import { Guardian } from '@xaamin/guardian';

Guardian.define('factura.global.listar', (user) => {
  return user.can('factura.global.listar');
});
